import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SpiickLanding from './pages/SpiickLanding';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SpiickLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
